module.exports = __webpack_public_path__ + "img/juyuan@2x.8d247f65.png";